import {
  GET_IN_TOUCH_SUPPORT_FAB_TITLE,
  resolveSupportFabGetInTouchContent,
} from 'pages/pii-verification/piiGetInTouchSupportFab.data';
import { userPaths } from 'routes/constants/userPaths';

import { shouldUseEuSupportTicketsEndpoint } from 'hooks/useContactSupport/contactSupportPath.data';

import type { PiiVerificationLocationState } from 'pages/pii-verification/piiGetInTouchNavigation.data';

/** Exact paths where the floating Support button must not appear. */
const END_USER_SUPPORT_FAB_EXCLUDED_PATHS = new Set<string>([
  userPaths.piiVerification,
  userPaths.hsaSuccess,
  userPaths.onboardingFindExpensesSuccess,
  userPaths.dashboard,
  userPaths.finchConnection,
]);

function isOnboardingOrTpaConnectionPath(pathname: string): boolean {
  if (pathname.startsWith(userPaths.onboarding)) {
    return true;
  }

  return pathname === userPaths.finchConnection;
}

/**
 * Show FAB only when profile is profile_enhanced, deduction_setup_created, or
 * deduction_setup_verified — and never on onboarding or TPA connection screens.
 */
export function shouldShowEndUserSupportFab(
  pathname: string,
  profileState?: string | null
): boolean {
  if (!pathname.startsWith(userPaths.base)) {
    return false;
  }

  if (END_USER_SUPPORT_FAB_EXCLUDED_PATHS.has(pathname)) {
    return false;
  }

  if (isOnboardingOrTpaConnectionPath(pathname)) {
    return false;
  }

  if (!shouldUseEuSupportTicketsEndpoint(profileState)) {
    return false;
  }

  return true;
}

/**
 * Build Get-in-touch navigation state for the Support FAB.
 * Title is set before navigate; Need help? has no info subtitle.
 */
export function buildEndUserSupportFabNavigationState(
  pathname: string,
  search = ''
): PiiVerificationLocationState {
  const content = resolveSupportFabGetInTouchContent();

  return {
    openGetInTouch: true,
    fromSupportFab: true,
    supportFabTitle: content.title || GET_IN_TOUCH_SUPPORT_FAB_TITLE,
    returnTo: `${pathname}${search}`,
  };
}
